app.directive('input', [function () {
        return {
            restrict: 'E',
            compile: function () {
                return {
                    post: function (scope, element, attrs) {
                        var parent = element.parent();
                        if(parent.hasClass('item-input')) {
                            element.bind('focus', function () {
                                parent.addClass('is-focused');
                            });

                            element.bind('keyup', function () {
                                if(element.val() !== '') {
                                    parent.addClass('is-changed');
                                }else{
                                    parent.removeClass('is-changed');
                                }
                            });

                            element.bind('blur', function () {
                                parent.removeClass('is-focused');
                                if(element.val() !== '') {
                                    parent.addClass('is-dirty');
                                }else{
                                    parent.removeClass('is-dirty');
                                }
                            });
                        }

                        if(attrs.hasOwnProperty('disabled') && attrs.disabled === true) {
                            parent.addClass('is-disabled');
                        }
                    }
                };
            }
        }
    }]);
